import {Box, CircularProgress, Stack, Typography} from "@mui/material";
import {FormattedMessage, MessageDescriptor} from "react-intl";

type Props = {
    /// translation id of the message to display
    messageId?: MessageDescriptor;
};

/**
 * A screen (full-size widget) to display circular progress with an optional message.
 */
export default function LoadingScreen({messageId}: Props) {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                width: "100%",
            }}
        >
            <Stack alignItems="center">
                {messageId && (
                    <Typography variant="h4" color="primary">
                        <FormattedMessage {...messageId} />
                    </Typography>
                )}
                <CircularProgress size={messageId ? "10vh" : "15vh"} />
            </Stack>
        </Box>
    );
}
